import { FormElems } from 'components';
import { VERIFIED } from 'components/Onboarding/Mle/mle.utils';
import React from 'react'

const VerifyButton = (props) => {
    const {
        isVerified,
        field,
        isDisable,
        handleClick
    } = props;
    // console.log("verified", props);
  return (
    <>
    {isVerified && (
                <div className="form-field">
                    <div
                        className="form-section action"
                        style={{ 'margin-top': '0px' }}
                    >
                        <FormElems.Button
                            id={field.name}
                            buttonType='secondary'
                            text={VERIFIED}
                            handleClick={(e) => {e.preventDefault()}}
                            isDisable={true}
                        />
                    </div>
                </div>
            )}
            {!isVerified && (
                <div className="form-field">
                    <div
                        className="form-section action"
                        style={{ 'margin-top': '0px' }}
                    >
                        <FormElems.Button
                            id={field.name}
                            buttonType={field.buttonType}
                            text={field.label}
                            handleClick={e => {
                                handleClick(e)
                            }}
                            isDisable={!!isDisable}
                        />
                    </div>
                </div>
            )}
    </>
  )
}

export default VerifyButton
